export const getBankLogo = (bank) => {
  if (!bank) {
    return "https://nigerianbanks.xyz/logo/default-image.png";
  }
  return (
    banklist.find((b) => bank.code === b.code)?.logo ||
    (alternativeBankList.find((b) => bank.slug === b.slug)
      ? `https://supermx1.github.io/nigerian-banks-api/logos/${bank.slug}.png`
      : "https://nigerianbanks.xyz/logo/default-image.png")
  );
};

export const getProviderLogo = (provider) => {
  if (!provider) {
    return "";
  }
  return `https://payments.baxipay.com.ng/images/${provider.service_type}.jpg`;
};

export const banklist = [
  {
    name: "Access Bank",
    slug: "access-bank",
    code: "044",
    ussd: "*901#",
    logo: "https://nigerianbanks.xyz/logo/access-bank.png",
  },
  {
    name: "Access Bank (Diamond)",
    slug: "access-bank-diamond",
    code: "063",
    ussd: "*426#",
    logo: "https://nigerianbanks.xyz/logo/access-bank-diamond.png",
  },
  {
    name: "ALAT by WEMA",
    slug: "alat-by-wema",
    code: "035A",
    ussd: "*945*100#",
    logo: "https://nigerianbanks.xyz/logo/alat-by-wema.png",
  },
  {
    name: "ASO Savings and Loans",
    slug: "asosavings",
    code: "401",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/asosavings.png",
  },
  {
    name: "Bowen Microfinance Bank",
    slug: "bowen-microfinance-bank",
    code: "50931",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "CEMCS Microfinance Bank",
    slug: "cemcs-microfinance-bank",
    code: "50823",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/cemcs-microfinance-bank.png",
  },
  {
    name: "Citibank Nigeria",
    slug: "citibank-nigeria",
    code: "023",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/citibank-nigeria.png",
  },
  {
    name: "Ecobank Nigeria",
    slug: "ecobank-nigeria",
    code: "050",
    ussd: "*326#",
    logo: "https://nigerianbanks.xyz/logo/ecobank-nigeria.png",
  },
  {
    name: "Ekondo Microfinance Bank",
    slug: "ekondo-microfinance-bank",
    code: "562",
    ussd: "*540*178#",
    logo: "https://nigerianbanks.xyz/logo/ekondo-microfinance-bank.png",
  },
  {
    name: "Fidelity Bank",
    slug: "fidelity-bank",
    code: "070",
    ussd: "*770#",
    logo: "https://nigerianbanks.xyz/logo/fidelity-bank.png",
  },
  {
    name: "First Bank of Nigeria",
    slug: "first-bank-of-nigeria",
    code: "011",
    ussd: "*894#",
    logo: "https://nigerianbanks.xyz/logo/first-bank-of-nigeria.png",
  },
  {
    name: "First City Monument Bank",
    slug: "first-city-monument-bank",
    code: "214",
    ussd: "*329#",
    logo: "https://nigerianbanks.xyz/logo/first-city-monument-bank.png",
  },
  {
    name: "Globus Bank",
    slug: "globus-bank",
    code: "00103",
    ussd: "*989#",
    logo: "https://nigerianbanks.xyz/logo/globus-bank.png",
  },
  {
    name: "Guaranty Trust Bank",
    slug: "guaranty-trust-bank",
    code: "058",
    ussd: "*737#",
    logo: "https://nigerianbanks.xyz/logo/guaranty-trust-bank.png",
  },
  {
    name: "Hasal Microfinance Bank",
    slug: "hasal-microfinance-bank",
    code: "50383",
    ussd: "*322*127#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Heritage Bank",
    slug: "heritage-bank",
    code: "030",
    ussd: "*322#",
    logo: "https://nigerianbanks.xyz/logo/heritage-bank.png",
  },
  {
    name: "Jaiz Bank",
    slug: "jaiz-bank",
    code: "301",
    ussd: "*389*301#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Keystone Bank",
    slug: "keystone-bank",
    code: "082",
    ussd: "*7111#",
    logo: "https://nigerianbanks.xyz/logo/keystone-bank.png",
  },
  {
    name: "Kuda Bank",
    slug: "kuda-bank",
    code: "50211",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/kuda-bank.png",
  },
  {
    name: "Lotus Bank",
    slug: "lotus-bank",
    code: "303",
    ussd: "*5045#",
    logo: "https://nigerianbanks.xyz/logo/lotus-bank.png",
  },
  {
    name: "Moniepoint MFB",
    slug: "moniepoint-mfb-ng",
    code: "50515",
    ussd: "*5573#",
    logo: "https://nigerianbanks.xyz/logo/moniepoint-mfb-ng.png",
  },
  {
    name: "One Finance",
    slug: "one-finance",
    code: "565",
    ussd: "*1303#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "OPay",
    slug: "paycom",
    code: "999992",
    ussd: "*955#",
    logo: "https://nigerianbanks.xyz/logo/paycom.png",
  },
  {
    name: "Paga",
    slug: "paga",
    code: "327",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/paga.png",
  },
  {
    name: "PalmPay",
    slug: "palmpay",
    code: "999991",
    ussd: "*861#",
    logo: "https://nigerianbanks.xyz/logo/palmpay.png",
  },
  {
    name: "Parallex Bank",
    slug: "parallex-bank",
    code: "526",
    ussd: "*322*318*0#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "PayCom",
    slug: "paycom",
    code: "100004",
    ussd: "*955#",
    logo: "https://nigerianbanks.xyz/logo/paycom.png",
  },
  {
    name: "Polaris Bank",
    slug: "polaris-bank",
    code: "076",
    ussd: "*833#",
    logo: "https://nigerianbanks.xyz/logo/polaris-bank.png",
  },
  {
    name: "Providus Bank",
    slug: "providus-bank",
    code: "101",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Rubies MFB",
    slug: "rubies-mfb",
    code: "125",
    ussd: "*7797#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Sparkle Microfinance Bank",
    slug: "sparkle-microfinance-bank",
    code: "51310",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/sparkle-microfinance-bank.png",
  },
  {
    name: "Stanbic IBTC Bank",
    slug: "stanbic-ibtc-bank",
    code: "221",
    ussd: "*909#",
    logo: "https://nigerianbanks.xyz/logo/stanbic-ibtc-bank.png",
  },
  {
    name: "Standard Chartered Bank",
    slug: "standard-chartered-bank",
    code: "068",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/standard-chartered-bank.png",
  },
  {
    name: "Sterling Bank",
    slug: "sterling-bank",
    code: "232",
    ussd: "*822#",
    logo: "https://nigerianbanks.xyz/logo/sterling-bank.png",
  },
  {
    name: "Suntrust Bank",
    slug: "suntrust-bank",
    code: "100",
    ussd: "*5230#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "TAJ Bank",
    slug: "taj-bank",
    code: "302",
    ussd: "*898#",
    logo: "https://nigerianbanks.xyz/logo/taj-bank.png",
  },
  {
    name: "TCF MFB",
    slug: "tcf-mfb",
    code: "51211",
    ussd: "*908#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Titan Trust Bank",
    slug: "titan-trust-bank",
    code: "102",
    ussd: "*922#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Union Bank of Nigeria",
    slug: "union-bank-of-nigeria",
    code: "032",
    ussd: "*826#",
    logo: "https://nigerianbanks.xyz/logo/union-bank-of-nigeria.png",
  },
  {
    name: "United Bank For Africa",
    slug: "united-bank-for-africa",
    code: "033",
    ussd: "*919#",
    logo: "https://nigerianbanks.xyz/logo/united-bank-for-africa.png",
  },
  {
    name: "Unity Bank",
    slug: "unity-bank",
    code: "215",
    ussd: "*7799#",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "VFD",
    slug: "vfd",
    code: "566",
    ussd: "",
    logo: "https://nigerianbanks.xyz/logo/default-image.png",
  },
  {
    name: "Wema Bank",
    slug: "wema-bank",
    code: "035",
    ussd: "*945#",
    logo: "https://nigerianbanks.xyz/logo/wema-bank.png",
  },
  {
    name: "Zenith Bank",
    slug: "zenith-bank",
    code: "057",
    ussd: "*966#",
    logo: "https://nigerianbanks.xyz/logo/zenith-bank.png",
  },
];

export const alternativeBankList = [
  {
    id: 697,
    name: "Branch International Financial Services Limited",
    slug: "branch",
    code: "FC40163",
    logo: "logos/branch.png",
  },
  {
    id: 167,
    name: "Eyowo",
    slug: "eyowo",
    code: "50126",
    logo: "logos/eyowo.png",
    ussd: "*4255#",
  },
  {
    id: 705,
    name: "Platinum Mortgage Bank",
    slug: "platinum-mortgage-bank-ng",
    code: "268",
    longcode: "null",
    logo: "logos/platinum-mortgage-bank-ng.png",
  },
  {
    id: 283,
    name: "Corestep MFB",
    slug: "corestep-mfb",
    code: "50204",
    logo: "logos/corestep-mfb.png",
  },
  {
    id: 108,
    name: "Bowen Microfinance Bank",
    slug: "bowen-microfinance-bank",
    code: "50931",
    logo: "logos/bowen-microfinance-bank.png",
  },
  {
    id: 282,
    name: "Unical MFB",
    slug: "unical-mfb",
    code: "50871",
    logo: "logos/unical-mfb.png",
  },
  {
    id: 701,
    name: "Waya Microfinance Bank",
    slug: "waya-microfinance-bank-ng",
    code: "51355",
    longcode: "51355",
    logo: "logos/waya-microfinance-bank-ng.png",
  },
  {
    id: 629,
    name: "Titan Paystack",
    slug: "titan-paystack",
    code: "100039",
    logo: "logos/titan-paystack.png",
  },
  {
    id: 69,
    name: "Rubies MFB",
    slug: "rubies-mfb",
    code: "125",
    logo: "logos/rubies-mfb.png",
    ussd: " *7797#",
  },
  {
    id: 10,
    name: "Heritage Bank",
    slug: "heritage-bank",
    code: "030",
    longcode: "030159992",
    logo: "logos/heritage-bank.png",
    ussd: "*745#",
    ussd_transfer: "*745*2*{{ amt }}*{{ acc }}#",
  },
  {
    id: 9,
    name: "Guaranty Trust Bank",
    slug: "guaranty-trust-bank",
    code: "058",
    longcode: "058152036",
    logo: "logos/guaranty-trust-bank.png",
    ussd: "*737#",
    ussd_transfer: "*737*1*{{ amt }}*{{ acc }}#",
  },
  {
    id: 16,
    name: "Sterling Bank",
    slug: "sterling-bank",
    code: "232",
    longcode: "232150016",
    logo: "logos/sterling-bank.png",
    ussd: "*822#",
    ussd_transfer: "*822*{{ amt }}*{{ acc }}#",
  },
  {
    id: 183,
    name: "GoMoney",
    slug: "gomoney",
    code: "100022",
    logo: "logos/gomoney.png",
  },
  {
    id: 109,
    name: "Lagos Building Investment Company Plc.",
    slug: "lbic-plc",
    code: "90052",
    logo: "logos/lbic-plc.png",
  },
  {
    id: 18,
    name: "United Bank For Africa",
    slug: "united-bank-for-africa",
    code: "033",
    longcode: "033153513",
    logo: "logos/united-bank-for-africa.png",
    ussd: "*919#",
    ussd_transfer: "*919*3*{{ amt }}*{{ acc }}#",
  },
  {
    id: 286,
    name: "Safe Haven MFB",
    slug: "safe-haven-mfb-ng",
    code: "51113",
    longcode: "51113",
    logo: "logos/safe-haven-mfb-ng.png",
  },
  {
    id: 4,
    name: "Ecobank Nigeria",
    slug: "ecobank-nigeria",
    code: "050",
    longcode: "050150010",
    logo: "logos/ecobank-nigeria.png",
    ussd: "*326#",
  },
  {
    id: 614,
    name: "Aramoko MFB",
    slug: "aramoko-mfb",
    code: "50083",
    logo: "logos/aramoko-mfb.png",
  },
  {
    id: 180,
    name: "Links MFB",
    slug: "links-mfb",
    code: "50549",
    logo: "logos/links-mfb.png",
  },
  {
    id: 110,
    name: "Parkway - ReadyCash",
    slug: "parkway-ready-cash",
    code: "311",
    logo: "logos/parkway-ready-cash.png",
  },
  {
    id: 174,
    name: "Abbey Mortgage Bank",
    slug: "abbey-mortgage-bank",
    code: "801",
    logo: "logos/abbey-mortgage-bank.png",
    ussd: "*332#",
  },
  {
    id: 679,
    name: "ROCKSHIELD MICROFINANCE BANK",
    slug: "rockshield-microfinance-bank-ng",
    code: "50767",
    logo: "logos/rockshield-microfinance-bank-ng.png",
  },
  {
    id: 67,
    name: "Kuda Bank",
    slug: "kuda-bank",
    code: "50211",
    logo: "logos/kuda-bank.png",
    ussd: "*894#",
  },
  {
    id: 495,
    name: "Accion Microfinance Bank",
    slug: "accion-microfinance-bank-ng",
    code: "602",
    logo: "logos/accion-microfinance-bank-ng.png",
    ussd: "*572#",
  },
  {
    id: 181,
    name: "Bainescredit MFB",
    slug: "bainescredit-mfb",
    code: "51229",
    logo: "logos/bainescredit-mfb.png",
  },
  {
    id: 693,
    name: "Peace Microfinance Bank",
    slug: "peace-microfinance-bank-ng",
    code: "50743",
    longcode: "50743",
    logo: "logos/peace-microfinance-bank-ng.png",
  },
  {
    id: 70,
    name: "Globus Bank",
    slug: "globus-bank",
    code: "00103",
    longcode: "103015001",
    logo: "logos/globus-bank.png",
    ussd: "*989#",
    ussd_transfer: "*989*2*{{ amt }}*{{ acc }}#",
  },
  {
    id: 297,
    name: "Astrapolaris MFB LTD",
    slug: "astrapolaris-mfb",
    code: "MFB50094",
    logo: "logos/astrapolaris-mfb.png",
  },
  {
    id: 688,
    name: "Moniepoint MFB",
    slug: "moniepoint-mfb-ng",
    code: "50515",
    longcode: "null",
    logo: "logos/moniepoint-mfb-ng.png",
    ussd: "*888#",
  },
  {
    id: 23,
    name: "Suntrust Bank",
    slug: "suntrust-bank",
    code: "100",
    logo: "logos/suntrust-bank.png",
    ussd: "*5230#",
  },
  {
    id: 188,
    name: "Above Only MFB",
    slug: "above-only-mfb",
    code: "51204",
    logo: "logos/above-only-mfb.png",
  },
  {
    id: 19,
    name: "Unity Bank",
    slug: "unity-bank",
    code: "215",
    longcode: "215154097",
    logo: "logos/unity-bank.png",
    ussd: "*7799#",
    ussd_transfer: "*7799*1*{{ acc }}*{{ amt }}#",
  },
  {
    id: 8,
    name: "First City Monument Bank",
    slug: "first-city-monument-bank",
    code: "214",
    longcode: "214150018",
    logo: "logos/first-city-monument-bank.png",
    ussd: "*329#",
    ussd_transfer: "*329*{{ amt }}*{{ acc }}#",
  },
  {
    id: 365,
    name: "Solid Rock MFB",
    slug: "solid-rock-mfb",
    code: "50800",
    logo: "logos/solid-rock-mfb.png",
  },
  {
    id: 72,
    name: "Sparkle Microfinance Bank",
    slug: "sparkle-microfinance-bank",
    code: "51310",
    logo: "logos/sparkle-microfinance-bank.png",
  },
  {
    id: 295,
    name: "Refuge Mortgage Bank",
    slug: "refuge-mortgage-bank",
    code: "90067",
    logo: "logos/refuge-mortgage-bank.png",
  },
  {
    id: 636,
    name: "Ilaro Poly Microfinance Bank",
    slug: "ilaro-poly-microfinance-bank-ng",
    code: "50442",
    logo: "logos/ilaro-poly-microfinance-bank-ng.png",
  },
  {
    id: 173,
    name: "Coronation Merchant Bank",
    slug: "coronation-merchant-bank-ng",
    code: "559",
    logo: "logos/coronation-merchant-bank-ng.png",
  },
  {
    id: 690,
    name: "U&C Microfinance Bank Ltd (U AND C MFB)",
    slug: "uc-microfinance-bank-ltd-u-and-c-mfb-ng",
    code: "50840",
    longcode: "50840",
    logo: "logos/uc-microfinance-bank-ltd-u-and-c-mfb-ng.png",
  },
  {
    id: 68,
    name: "TAJ Bank",
    slug: "taj-bank",
    code: "302",
    logo: "logos/taj-bank.png",
    ussd: "*898#",
    ussd_transfer: "*898*{{ amt }}*{{ acc }}#",
  },
  {
    id: 233,
    name: "Lotus Bank",
    slug: "lotus-bank",
    code: "303",
    logo: "logos/lotus-bank.png",
    ussd: "*5045#",
  },
  {
    id: 304,
    name: "PremiumTrust Bank",
    slug: "premiumtrust-bank-ng",
    code: "105",
    longcode: "000031",
    logo: "logos/premiumtrust-bank-ng.png",
    ussd: "*858#",
  },
  {
    id: 302,
    name: "9mobile 9Payment Service Bank",
    slug: "9mobile-9payment-service-bank-ng",
    code: "120001",
    longcode: "120001",
    logo: "logos/9mobile-9payment-service-bank-ng.png",
    ussd: "*990# ",
  },
  {
    id: 303,
    name: "MTN Momo PSB",
    slug: "mtn-momo-psb-ng",
    code: "120003",
    longcode: "120003",
    logo: "logos/mtn-momo-psb-ng.png",
    ussd: "*671#",
  },
  {
    id: 75,
    name: "TCF MFB",
    slug: "tcf-mfb",
    code: "51211",
    logo: "logos/tcf-mfb.png",
  },
  {
    id: 168,
    name: "Ibile Microfinance Bank",
    slug: "ibile-mfb",
    code: "51244",
    logo: "logos/ibile-mfb.png",
  },
  {
    id: 692,
    name: "CASHCONNECT MFB",
    slug: "cashconnect-mfb-ng",
    code: "865",
    longcode: "865",
    logo: "logos/cashconnect-mfb-ng.png",
  },
  {
    id: 172,
    name: "Infinity MFB",
    slug: "infinity-mfb",
    code: "50457",
    logo: "logos/infinity-mfb.png",
  },
  {
    id: 25,
    name: "Providus Bank",
    slug: "providus-bank",
    code: "101",
    logo: "logos/providus-bank.png",
  },
  {
    id: 682,
    name: "FirstTrust Mortgage Bank Nigeria",
    slug: "firsttrust-mortgage-bank-nigeria-ng",
    code: "413",
    logo: "logos/firsttrust-mortgage-bank-nigeria-ng.png",
  },
  {
    id: 628,
    name: "Ekimogun MFB",
    slug: "ekimogun-mfb-ng",
    code: "50263",
    logo: "logos/ekimogun-mfb-ng.png",
  },
  {
    id: 635,
    name: "Goodnews Microfinance Bank",
    slug: "goodnews-microfinance-bank-ng",
    code: "50739",
    logo: "logos/goodnews-microfinance-bank-ng.png",
  },
  {
    id: 638,
    name: "Unilag Microfinance Bank",
    slug: "unilag-microfinance-bank-ng",
    code: "51316",
    logo: "logos/unilag-microfinance-bank-ng.png",
  },
  {
    id: 176,
    name: "Rand Merchant Bank",
    slug: "rand-merchant-bank",
    code: "502",
    logo: "logos/rand-merchant-bank.png",
  },
  {
    id: 17,
    name: "Union Bank of Nigeria",
    slug: "union-bank-of-nigeria",
    code: "032",
    longcode: "032080474",
    logo: "logos/union-bank-of-nigeria.png",
    ussd: "*826#",
    ussd_transfer: "*826*2*{{ amt }}*{{ acc }}#",
  },
  {
    id: 177,
    name: "Firmus MFB",
    slug: "firmus-mfb",
    code: "51314",
    logo: "logos/firmus-mfb.png",
  },
  {
    id: 13,
    name: "Polaris Bank",
    slug: "polaris-bank",
    code: "076",
    longcode: "076151006",
    logo: "logos/polaris-bank.png",
    ussd: "*833#",
    ussd_transfer: "*833*{{ amt }}*{{ acc }}#",
  },
  {
    id: 285,
    name: "Stellas MFB",
    slug: "stellas-mfb",
    code: "51253",
    logo: "logos/stellas-mfb.png",
  },
  {
    id: 695,
    name: "Solid Allianze MFB",
    slug: "solid-allianze-mfb",
    code: "51062",
    logo: "logos/solid-allianze-mfb.png",
  },
  {
    id: 287,
    name: "Gateway Mortgage Bank LTD",
    slug: "gateway-mortgage-bank",
    code: "812",
    logo: "logos/gateway-mortgage-bank.png",
  },
  {
    id: 74,
    name: "CEMCS Microfinance Bank",
    slug: "cemcs-microfinance-bank",
    code: "50823",
    logo: "logos/cemcs-microfinance-bank.png",
  },
  {
    id: 691,
    name: "Consumer Microfinance Bank",
    slug: "consumer-microfinance-bank-ng",
    code: "50910",
    longcode: "50910",
    logo: "logos/consumer-microfinance-bank-ng.png",
  },
  {
    id: 81,
    name: "Hasal Microfinance Bank",
    slug: "hasal-microfinance-bank",
    code: "50383",
    logo: "logos/hasal-microfinance-bank.png",
  },
  {
    id: 82,
    name: "Carbon",
    slug: "carbon",
    code: "565",
    logo: "logos/carbon.png",
  },
  {
    id: 11,
    name: "Keystone Bank",
    slug: "keystone-bank",
    code: "082",
    longcode: "082150017",
    logo: "logos/keystone-bank.png",
    ussd: "*7111#",
    ussd_transfer: "*7111*{{ amt }}*{{ acc }}#",
  },
  {
    id: 615,
    name: "Ikoyi Osun MFB",
    slug: "ikoyi-osun-mfb",
    code: "50439",
    logo: "logos/ikoyi-osun-mfb.png",
  },
  {
    id: 689,
    name: "AMPERSAND MICROFINANCE BANK",
    slug: "ampersand-microfinance-bank-ng",
    code: "51341",
    logo: "logos/ampersand-microfinance-bank-ng.png",
  },
  {
    id: 704,
    name: "Chikum Microfinance bank",
    slug: "chikum-microfinance-bank-ng",
    code: "312",
    longcode: "null",
    logo: "logos/chikum-microfinance-bank-ng.png",
  },
  {
    id: 707,
    name: "Amegy Microfinance Bank",
    slug: "amegy-microfinance-bank-ng",
    code: "090629",
    longcode: "090629",
    logo: "logos/amegy-microfinance-bank-ng.png",
  },
  {
    id: 703,
    name: "Imowo MFB",
    slug: "imowo-mfb-ng",
    code: "50453",
    longcode: "50453",
    logo: "logos/imowo-mfb-ng.png",
  },
  {
    id: 706,
    name: "SAGE GREY FINANCE LIMITED",
    slug: "sage-grey-finance-limited-ng",
    code: "40165",
    longcode: "null",
    logo: "logos/sage-grey-finance-limited-ng.png",
  },
  {
    id: 626,
    name: "Polyunwana MFB",
    slug: "polyunwana-mfb-ng",
    code: "50864",
    longcode: "null",
    logo: "logos/polyunwana-mfb-ng.png",
  },
  {
    id: 21,
    name: "Zenith Bank",
    slug: "zenith-bank",
    code: "057",
    longcode: "057150013",
    logo: "logos/zenith-bank.png",
    ussd: "*966#",
    ussd_transfer: "*966*{{ amt }}*{{ acc }}#",
  },
  {
    id: 6,
    name: "Fidelity Bank",
    slug: "fidelity-bank",
    code: "070",
    longcode: "070150003",
    logo: "logos/fidelity-bank.png",
    ussd: "*770#",
    ussd_transfer: "*770*{{ acc }}*{{ amt }}#",
  },
  {
    id: 15,
    name: "Standard Chartered Bank",
    slug: "standard-chartered-bank",
    code: "068",
    longcode: "068150015",
    logo: "logos/standard-chartered-bank.png",
  },
  {
    id: 627,
    name: "Abulesoro MFB",
    slug: "abulesoro-mfb-ng",
    code: "51312",
    logo: "logos/abulesoro-mfb-ng.png",
  },
  {
    id: 187,
    name: "Kadpoly MFB",
    slug: "kadpoly-mfb",
    code: "50502",
    logo: "logos/kadpoly-mfb.png",
  },
  {
    id: 232,
    name: "QuickFund MFB",
    slug: "quickfund-mfb",
    code: "51293",
    logo: "logos/quickfund-mfb.png",
  },
  {
    id: 26,
    name: "Parallex Bank",
    slug: "parallex-bank",
    code: "104",
    logo: "logos/parallex-bank.png",
    ussd: "*1242#",
  },
  {
    id: 296,
    name: "Living Trust Mortgage Bank",
    slug: "living-trust-mortgage-bank",
    code: "031",
    logo: "logos/living-trust-mortgage-bank.png",
    ussd: "*723*312#",
  },
  {
    id: 14,
    name: "Stanbic IBTC Bank",
    slug: "stanbic-ibtc-bank",
    code: "221",
    longcode: "221159522",
    logo: "logos/stanbic-ibtc-bank.png",
    ussd: "*909#",
    ussd_transfer: "*909*22*{{ amt }}*{{ acc }}#",
  },
  {
    id: 186,
    name: "Tangerine Money",
    slug: "tangerine-money",
    code: "51269",
    logo: "logos/tangerine-money.png",
  },
  {
    id: 64,
    name: "Ekondo Microfinance Bank",
    slug: "ekondo-microfinance-bank-ng",
    code: "098",
    logo: "logos/ekondo-microfinance-bank-ng.png",
  },
  {
    id: 687,
    name: "FLOURISH MFB",
    slug: "flourish-mfb-ng",
    code: "50315",
    longcode: "50315",
    logo: "logos/flourish-mfb-ng.png",
  },
  {
    id: 699,
    name: "Optimus Bank Limited",
    slug: "optimus-bank-ltd",
    code: "107",
    longcode: "00107",
    logo: "logos/optimus-bank-ltd.png",
    ussd: "*930#",
  },
  {
    id: 637,
    name: "Dot Microfinance Bank",
    slug: "dot-microfinance-bank-ng",
    code: "50162",
    logo: "logos/dot-microfinance-bank-ng.png",
  },
  {
    id: 179,
    name: "Amju Unique MFB",
    slug: "amju-unique-mfb",
    code: "50926",
    longcode: "511080896",
    logo: "logos/amju-unique-mfb.png",
  },
  {
    id: 301,
    name: "HopePSB",
    slug: "hopepsb-ng",
    code: "120002",
    longcode: "120002",
    logo: "logos/hopepsb-ng.png",
  },
  {
    id: 7,
    name: "First Bank of Nigeria",
    slug: "first-bank-of-nigeria",
    code: "011",
    longcode: "011151003",
    logo: "logos/first-bank-of-nigeria.png",
    ussd: "*894#",
    ussd_transfer: "*894*{{ amt }}*{{ acc }}#",
  },
  {
    id: 3,
    name: "Access Bank (Diamond)",
    slug: "access-bank-diamond",
    code: "063",
    longcode: "063150162",
    logo: "logos/access-bank-diamond.png",
    ussd: "*901#",
    ussd_transfer: "*901*2*{{ amt }}*{{ amt }}#",
  },
  {
    id: 630,
    name: "Uhuru MFB",
    slug: "uhuru-mfb-ng",
    code: "MFB51322",
    logo: "logos/uhuru-mfb-ng.png",
  },
  {
    id: 609,
    name: "Safe Haven Microfinance Bank Limited",
    slug: "safe-haven-microfinance-bank-limited-ng",
    code: "951113",
    logo: "logos/safe-haven-microfinance-bank-limited-ng.png",
  },
  {
    id: 632,
    name: "Shield MFB",
    slug: "shield-mfb-ng",
    code: "50582",
    logo: "logos/shield-mfb-ng.png",
  },
  {
    id: 284,
    name: "Chanelle Microfinance Bank Limited",
    slug: "chanelle-microfinance-bank-limited-ng",
    code: "50171",
    longcode: "50171",
    logo: "logos/chanelle-microfinance-bank-limited-ng.png",
  },
  {
    id: 22,
    name: "Jaiz Bank",
    slug: "jaiz-bank",
    code: "301",
    longcode: "301080020",
    logo: "logos/jaiz-bank.png",
    ussd: "*773#",
    ussd_transfer: "*773*{{ amt }}*{{ acc }}#",
  },
  {
    id: 1,
    name: "Access Bank",
    slug: "access-bank",
    code: "044",
    longcode: "044150149",
    logo: "logos/access-bank.png",
    ussd: "*901#",
    ussd_transfer: "*901*2*{{ amt }}*{{ amt }}#",
  },
  {
    id: 71,
    name: "VFD Microfinance Bank Limited",
    slug: "vfd",
    code: "566",
    logo: "logos/vfd.png",
    ussd: "*5037#",
  },
  {
    id: 184,
    name: "Kredi Money MFB LTD",
    slug: "kredi-money-mfb",
    code: "50200",
    logo: "logos/kredi-money-mfb.png",
  },
  {
    id: 178,
    name: "Mint MFB",
    slug: "mint-mfb",
    code: "50304",
    logo: "logos/mint-mfb.png",
  },
  {
    id: 300,
    name: "Airtel Smartcash PSB",
    slug: "airtel-smartcash-psb-ng",
    code: "120004",
    longcode: "120004",
    logo: "logos/airtel-smartcash-psb-ng.png",
  },
];
